import { ReactNode } from 'react'
import { ButtonProps, Flex, FlexProps } from 'antd'
import SaveButton from './SaveButton'
import CancelButton from './CancelButton'
import DeleteButton from './DeleteButton'

type CustomProps = {
  customText?: ReactNode
} & ButtonProps

interface IProps {
  hideSave?: boolean
  hideCancel?: boolean
  hideDelete?: boolean
  onClickSave?: () => void
  onClickCancel?: () => void
  onClickDelete?: () => void
  loadingSave?: boolean
  customProps?: {
    saveProps?: CustomProps
    cancelProps?: CustomProps
    deleteProps?: CustomProps
  }
  containerFlexProps?: Partial<FlexProps>
}

const FormFooterButtons = (props: IProps) => {
  const {
    customProps,
    containerFlexProps,
    loadingSave,
    hideCancel,
    hideDelete,
    hideSave,
    onClickCancel,
    onClickDelete,
    onClickSave,
  } = props

  const { cancelProps, deleteProps, saveProps } = customProps || {}

  const saveButton = !hideSave && (
    <SaveButton onClick={onClickSave} loading={loadingSave} {...saveProps} />
  )

  const cancelButton = !hideCancel && (
    <CancelButton onClick={onClickCancel} {...cancelProps} />
  )

  const deleteButton = !hideDelete && (
    <DeleteButton onClick={onClickDelete} {...deleteProps} />
  )

  return (
    <Flex
      justify={hideDelete ? 'flex-end' : 'space-between'}
      gap={6}
      {...containerFlexProps}
    >
      {deleteButton}
      <Flex gap={6}>
        {cancelButton}
        {saveButton}
      </Flex>
    </Flex>
  )
}

export default FormFooterButtons
